<template>
    <div>
        <div v-if="authUserPermission['sap-sync-task-view']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>      
                </div>
            </base-header>

            <div class="container-fluid mt--6">
                <div class="card mb-4">
                    <div class="card-header mt--4 mb-0">
                        <div class="row justify-content-between">
                            <div class="col-5">
                                <h3>{{ tt('sap_synchron_task') }}</h3>
                            </div>
                            <div class="col-5 d-flex">
                                <el-input class="text-center mr-2" v-model="table.search" :placeholder="tt('search_sap_synchron_task')" @change="filter"/>
                                <base-button v-if="authUserPermission['add-new-sap-task']" size="sm w-50" type="primary" @click="formAdd.show = true">New Sap Task</base-button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-table height="500px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table.data" v-if="!onLoad">
                            <el-table-column :label="tt('sap_sync_id')" :prop="tt('sap_sync_id')" min-width="170px" sortable>
                                <template v-slot="{row}">
                                    {{row.sap_sync_id}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('connection')" :prop="tt('connection')" min-width="160px" sortable>
                                <template v-slot="{row}">
                                    {{row.sap_conn['connection']}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('mcr_number')" :prop="tt('mcr_number')" min-width="160px" sortable>
                                <template v-slot="{row}">
                                    {{row.mcr_number}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('key')" :prop="tt('key')" min-width="180px" sortable>
                                <template v-slot="{row}">
                                    {{row.key}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('requested_by')" :prop="tt('requested_by')" min-width="190px" sortable>
                                <template v-slot="{row}">
                                    {{row.requested_by}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('requested_at')" :prop="tt('requested_at')" min-width="190px" sortable>
                                <template v-slot="{row}">
                                    {{row.requested_at}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('executed_at')" :prop="tt('executed_at')" min-width="190px" sortable>
                                <template v-slot="{row}">
                                    {{row.executed_at}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('done_at')" :prop="tt('done_at')" min-width="190px" sortable>
                                <template v-slot="{row}">
                                    {{row.done_at}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('status')" :prop="tt('status')" min-width="120px" sortable>
                                <template v-slot="{row}">
                                    <label class="badge badge-primary" v-if="row.status == '0'">WAITING</label>
                                    <label class="badge badge-success" v-else-if="row.status == '1'">SUCCESS</label>
                                    <label class="badge badge-danger" v-else-if="row.status == '-1'">FAILED</label>
                                </template>
                            </el-table-column>
                            <el-table-column prop="action" width="250">
                                <template v-slot="{row}">
                                    <div class="row">
                                        <div class="col text-right">
                                            <base-button size="sm" type="primary" @click="synchron(row.id)" v-if="row.status == '0' && row.key != null">
                                                <span v-if="btnSync[row.id]"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                                                <span v-else>{{ tt('synchron') }}</span>
                                            </base-button>
                                            <base-button size="sm" type="primary" @click="synchron(row.id)" v-if="row.status == '-1' && row.key != null" :disabled="btnSync[row.id]">
                                                <span v-if="btnSync[row.id]"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                                                <span v-else>{{ tt('re_synchron') }}</span>
                                            </base-button>
                                            <base-button size="sm" type="warning" @click="edit(row.key, row.id)" v-if="row.status == -1 && !!row.key && !!row.mcr_number">{{ tt('edit') }}</base-button>
                                            <base-button size="sm" type="dark" @click="task_log(row.id)">{{ tt('view_log') }}</base-button>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <skeleton-loading v-else/>
                    </div>
                    <div class="card-footer pb-0 ">   
                        <span class="float-left">
                            <base-pagination :page-count="table.page.last_page" v-model="table.page.current_page" @click.native="changePage(table.page.current_page)" size="sm"></base-pagination>
                        </span>                             
                        <span class="float-right">
                            {{ tt('page_info', {size: (table.page.current_page - 1) * table.page.per_page + table.data.length, total: table.total}) }}
                        </span>
                    </div>
                </div>
            </div>

            <modal :show.sync="form.show" size="lg">
                <template slot="header">
                    <h4 class="modal-title">{{form.title}}</h4>
                </template>
                <el-table height="500px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="sapSyncLog.data" v-if="!onLoad">
                <el-table-column :label="tt('sap_sync_task_id')" :prop="tt('sap_sync_task_id')" min-width="170px" sortable>
                    <template v-slot="{row}">
                        {{row.sap_sync_task_id}}
                    </template>
                </el-table-column>
                <el-table-column :label="tt('type')" :prop="tt('type')" min-width="170px" sortable>
                    <template v-slot="{row}">
                        {{row.type}}
                    </template>
                </el-table-column>
                <el-table-column :label="tt('message')" :prop="tt('message')" min-width="150px" sortable>
                    <template v-slot="{row}">
                        {{row.message}}
                    </template>
                </el-table-column>
                <el-table-column :label="tt('date')" :prop="tt('date')" min-width="190px" sortable>
                    <template v-slot="{row}">
                        {{row.timestamp}}
                    </template>
                </el-table-column>
            </el-table>
            </modal>

            <el-dialog
                title="Add SAP Sync Task"
                :visible.sync="formAdd.show"
                width="30%"
                :before-close="handleCloseModalAdd"
                :close-on-click-modal="false"
            >
                <div class="mb-4">
                    <label class="form-control-label">MCR Number</label>
                    <input placeholder="MCR Number" type="text" class="form-control" v-model="formAdd.data.mcr_number" />
                </div>
                <div class="d-flex justify-content-end">
                    <base-button type="light" @click="handleCloseModalAdd" :loading="formAdd.loading">Batal</base-button>
                    <base-button type="primary" @click="handleAddNewData" :loading="formAdd.loading">Add</base-button>
                </div>
            </el-dialog>

        </div>
        <noaccess v-else/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import sapSyncTask from '@/services/sap/sapSyncTask.service';
    import draftList from "@/services/material/draftList.service";
    import Swal from "sweetalert2";

    export default {        
        data() {
            return { 
                onLoad: true, 
                btnSync: [], 
                loadTimeout: null,                 
                form: {
                    add: true,
                    title: this.tt('add_sap_synchron_task'),
                    show: false
                }, 
                formAdd: {
                    show: false,
                    loading: false,
                    data: {
                        mcr_number: null
                    }
                },
                table: {
                    search: (this.$route.query.search) ? this.$route.query.search : '',                    
                    total: 0,
                    data: [],
                    page: {
                        current_page: 1,
                        per_page: 100,
                    },
                    log:[]
                },        
                sapSyncTask: {}, 
                sapSyncLog: {
                    data: [],
                }, 
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
        },
        methods: {
            handleTableAction(command) {
                switch (command.action) {
                    case 'synchron':
                            this.synchron(command.data);
                        break;
                    case 'task_log':
                            this.task_log(command.data);
                        break;
                    case 'edit':
                            this.edit(command.data);
                        break;
                    default:
                        break;
                }
            },
            handleAddNewData() {
                this.formAdd.loading = true
                 Api(this, sapSyncTask.manualSyncTask({mcr_number: this.formAdd.data.mcr_number}))
                    .onSuccess(response => {
                        console.log(response.data)    
                        Swal.fire({
                            text: response?.data?.message ?? 'SAP Sync Task Added Successfully',
                            icon: 'success',
                            confirmButtonText: 'OK'
                        }).then(() => {
                            this.formAdd.show = false
                            this.formAdd.data.mcr_number = null
                            this.get()
                        })
                    }).onError(error => {
                        const errorMessage = error?.response?.data?.message ?? 'Gagal, Terjadi kesalahan.'
                        this.$notify({
                            message: errorMessage,
                            type: 'danger',
                            verticalAlign: "bottom",
                            horizontalAlign: "left"
                        });
                    })
                    .onFinish(() => {
                        this.formAdd.loading = false
                    })
                    .call()
            },
            handleCloseModalAdd() {
                this.formAdd.show = false
                this.formAdd.loading = false
            },
            get() { 
                let context = this;               
                Api(context, sapSyncTask.get(this.table.page.current_page, {search: this.table.search})).onSuccess(function(response) {    
                    context.table.total = response.data.data.data.total;
                    context.table.data  = response.data.data.data.data;
                    context.table.page  = response.data.data.data;  
                    context.onLoad      = false;      
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.table.data = [];
                        context.table.total = 0;
                        context.onLoad = false;
                    }
                })
                .call()
            },
            filter() {
                if(this.table.search != this.$route.query.search){
                    this.onLoad = true;
                    this.table.page.current_page = 1;
                    clearTimeout(this.loadTimeout);
                    this.loadTimeout = setTimeout(() => {
                        if(this.table.search == ''){
                            this.$router.push({path:'/sap/sap-sync-task', query:null})
                        }else{
                            this.$router.push({path:'/sap/sap-sync-task', query:{search:this.table.search}})
                        }
                        this.get()
                    }, 100);
                }
            },
            synchron(id) {
                this.confirmDialog(this.tt('confirm_synchron')).then((result) => {
                    let context = this;
                    if (result.value) {
                        context.$set(context.btnSync, id, true);
                        const {sap_sync_id} = this.table.data.find(item => item.id = id)
                        console.log(sap_sync_id)
                        Api(
                            context, 
                            sap_sync_id == 'UpdateStockSAP' ? sapSyncTask.synchronUpdateStock(id) : sapSyncTask.synchron(id)
                        ).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                        }).onError(function(error) {                    
                           if (error.response.data.message) {
                                context.$notify({
                                    message: error.response.data.message,                  
                                    type: 'danger',
                                    verticalAlign: 'bottom', 
                                    horizontalAlign: 'left'
                                });           
                            }
                        }).onFinish(function(){
                            context.$set(context.btnSync, id, false);
                            context.get();
                        }).call()
                    }
                })
            },
            task_log(id) {
                let context = this;               
                Api(context, sapSyncTask.task_log(id)).onSuccess(function(response) {
                    context.sapSyncLog.data = response.data.data;
                    context.form.add        = false;
                    context.form.title      = context.tt('synchron_task_log');
                    context.form.show       = true;                      
                })
                .call() 
            },
            changePage(page) {
                let context = this;
                context.onLoad = true;
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
            edit(key, id = null) {
                let context = this;
                let current_task = null;

                if (id) {
                    current_task = context.table.data.find((item) => item.id == id);
                } else {
                    current_task = context.table.data.find((item) => item.key == key);
                }

                const sync_type = current_task.sap_sync_id == 'MaintainBom' ? 'sapSyncTaskEditEquipment' : 'sapSyncTaskEdit';   

                Api(context, draftList.get_emcr_from_item_mcr(key)).onSuccess(function(response) {
                    context.$router.push('/material/mcr-form/'+response.data.data[0].form_type+'/'+response.data.data[0].mcr_code+'/'+key+'/'+response.data.data[0].token+'/'+sync_type);
                })
                .call()
            },
        }   
    };
</script>
<style></style>
